import { TextField, type TextFieldProps } from '@mui/material';
import { type PropsWithChildren } from 'react';

type ReadOnlyTextField = {} & TextFieldProps;

export const ReadOnlyField = ({ children, ...props }: PropsWithChildren<ReadOnlyTextField>) => {
  return (
    <TextField
      variant="outlined"
      {...props}
      slotProps={{
        inputLabel: { shrink: true },
        htmlInput: { children, style: { padding: 16, width: '100%' } },
      }}
      slots={{ htmlInput: 'div' }}
    />
  );
};
